import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { Navigate, useTypedParams } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_HOME,
  FOOTBALL,
  LANDING,
  MLB,
  NBA,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import { localStorage } from '@sorare/core/src/lib/storage/localStorage.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const anonymousRoots: Record<string, string> = {
  football: FOOTBALL,
  baseball: MLB,
  mlb: MLB,
  nba: NBA,
};
const loggedInRoots: Record<string, Sport> = {
  football: Sport.FOOTBALL,
  nba: Sport.NBA,
  baseball: Sport.BASEBALL,
  mlb: Sport.BASEBALL,
};

const Referral = () => {
  const [searchParams] = useSearchParams();
  const { currentUser } = useCurrentUserContext();
  const { userSlug } = useTypedParams<PageParams>();

  const sport = searchParams.get('utm_term') || 'football';
  const root =
    (currentUser
      ? generateSportPath(ANY_SPORT_HOME, {
          sport: loggedInRoots[sport] || Sport.FOOTBALL,
        })
      : anonymousRoots[sport]) || LANDING;

  useEffect(() => {
    if (userSlug) {
      localStorage.setItem('REFERRER', userSlug);
    }
  }, [userSlug]);

  return <Navigate to={`${root}`} replace />;
};

export default Referral;
